import React from "react";
import ReactDOM from "react-dom";
import "../src/styles/index.scss";

// import objectFitImages from 'object-fit-images';
import App from "./components/app/app";

ReactDOM.render(<App />, document.getElementById("root"));
